import React from 'react';
import { useTranslation } from 'react-i18next';
import { X, HardDrive, AlertCircle } from 'lucide-react';
import './VideoTooShortModal.css';

export default function VideoTooLargeModal({ isOpen, onClose, message, isRtl }) {
  const { t, i18n } = useTranslation();
  const isHebrew = i18n.language && i18n.language.startsWith('he');
  const rtlClass = isHebrew || isRtl ? 'videoTooShortModal--rtl' : '';

  if (!isOpen) return null;

  return (
    <div className={`videoTooShortModal__overlay ${rtlClass}`} onClick={onClose}>
      <div className="videoTooShortModal__content" onClick={(e) => e.stopPropagation()}>
        <button className="videoTooShortModal__close" onClick={onClose}>
          <X size={20} />
        </button>
        
        <div className="videoTooShortModal__icon">
          <div className="videoTooShortModal__iconWrapper">
            <HardDrive size={40} className="videoTooShortModal__iconMain" />
          </div>
        </div>
        
        <h2 className="videoTooShortModal__title">
          {t('videoTooLargeModal.title', { defaultValue: 'Video Too Large' })}
        </h2>
        
        <p className="videoTooShortModal__message">
          {t('videoTooLargeModal.message', { defaultValue: message || 'Your video exceeds the maximum file size limit of 500MB.' })}
        </p>
        
        <div className="videoTooShortModal__info">
          <div className="videoTooShortModal__infoItem">
            <div className="videoTooShortModal__infoIcon">
              <AlertCircle size={18} />
            </div>
            <div className="videoTooShortModal__infoText">
              <strong>{t('videoTooLargeModal.suggestionTitle', { defaultValue: 'What can you do?' })}</strong>
              <p>{t('videoTooLargeModal.suggestionDescription', { defaultValue: 'Try compressing the video, recording a shorter clip, or reducing the video quality/resolution before uploading.' })}</p>
            </div>
          </div>
        </div>
        
        <div className="videoTooShortModal__actions">
          <button className="videoTooShortModal__button videoTooShortModal__button--primary" onClick={onClose}>
            {t('videoTooLargeModal.understood', { defaultValue: 'Got it' })}
          </button>
        </div>
      </div>
    </div>
  );
}

